import React, { Fragment } from 'react';

export const nl2br = (text) => {
  if (!text) return null;
  return text.split('\n').map((line, i, arr) => (
    <Fragment key={i}>
      {line}
      {i !== arr.length - 1 && <br />}
    </Fragment>
  ));
};

export default { nl2br };



// WEBPACK FOOTER //
// ./src/utils/nl2br.js